import tw, { styled } from 'twin.macro';

import { Flex } from '@sopranodesign/pulse-components';

const TopSection = styled(Flex)`
  ${tw`mb-2`}
  & > * {
    ${tw`m-0`}
  }
`;

export default TopSection;
